import "./landing-page-service-list.component.scss";

export default {
  template: require('./landing-page-service-list.component.html'),
  bindings: {
    services: "<",
    onServiceHover: "<vuiServiceHover"
  },
  controller: function () {
    'ngInject';

    const self = this;

  }
};
